// ── Firebase App Check 초기화 ──
// reCAPTCHA Enterprise 기반 — 공격자가 셈핏 외부에서 Firebase SDK로
// 직접 데이터 조작하는 걸 차단.
//
// 환경 변수: REACT_APP_RECAPTCHA_SITE_KEY (Google Cloud reCAPTCHA Enterprise 키)
// 미설정 시: App Check 미적용 — 정상 동작 유지하되 보안 약함

import { initializeAppCheck, ReCaptchaEnterpriseProvider, CustomProvider } from 'firebase/app-check';
import { app } from './firebase';
import { IS_CHINA_MODE } from './chinaMode';

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let appCheckInstance = null;

if (siteKey) {
  // 개발 환경: 디버그 토큰 자동 발급 (Firebase Console에서 토큰 등록 필요)
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  try {
    appCheckInstance = initializeAppCheck(app, {
      // V120: 중국 모드는 reCAPTCHA가 막혀 있어서 '기기 등록 코드'(디버그 토큰, chinaMode.js)로만 토큰을 받는다.
      // 그 경우 아래 provider는 쓰이지 않는다 — 막힌 reCAPTCHA 스크립트를 부르지 않게 빈 provider를 둔다.
      provider: IS_CHINA_MODE
        ? new CustomProvider({ getToken: () => Promise.reject(new Error('china mode: device token only')) })
        : new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
    if (process.env.NODE_ENV !== 'production') {
      console.log('🛡️ Firebase App Check 활성화 (reCAPTCHA Enterprise)');
    }
  } catch (e) {
    console.warn('App Check 초기화 실패:', e.message);
  }
} else {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('⚠️ REACT_APP_RECAPTCHA_SITE_KEY 미설정 — App Check 비활성. Vercel 환경변수 등록 필요.');
  }
}

export const appCheck = appCheckInstance;
